
import type { DefineComponent } from 'vue'
import { defineComponent, getCurrentInstance } from 'vue'
import { useTeleport } from '../../../composables/use-teleport'
import EpbModalWrapper from './epb-modal-wrapper.component.vue'

export default defineComponent({
  name: 'EpbModal',
  props: {
    ...(EpbModalWrapper as unknown as DefineComponent).props,
    refId: String,
  },
  emits: {
    close: () => {},
  },
  setup: (props, ctx) => {
    const {
      proxy: { $slots },
    } = getCurrentInstance()

    const modal = useTeleport(EpbModalWrapper, {
      props,
      emits: {
        close: onClose,
      },
      slots: $slots,
    })

    function onClose() {
      ctx.emit('close')
      modal.remove()
    }

    modal.render()

    return {
      open: () => modal.render(),
      close: onClose,
    }
  },
  beforeDestroy() {
    // Ensure the modal is removed when the component is destroyed
    // This is necessary because the modal is rendered outside the component
    // sadly the composable onBeforeUnmount is not called when the component is destroyed the component
    this.close()
  },
})
